import styles from "./index.module.less";
import img11 from "./imgs/img11.png";
import img12 from "./imgs/img12.png";
import img21 from "./imgs/img21.png";
import img22 from "./imgs/img22.png";
import img31 from "./imgs/img31.png";
import img32 from "./imgs/img32.png";
import img41 from "./imgs/img41.png";
import img42 from "./imgs/img42.png";
import { Flex, Rate } from "antd";
import { useEffect, useRef, useState } from "react";
import icon1 from "./imgs/logo1.png";
import icon2 from "./imgs/logo2.png";
import icon3 from "./imgs/logo3.png";
import icon4 from "./imgs/logo4.png";
import icon5 from "./imgs/logo5.png";
import icon6 from "./imgs/logo6.png";
import icon7 from "./imgs/logo7.png";
import icon8 from "./imgs/logo8.png";
const column1 = [
  {
    type: "img",
    url: img11,
  },
  {
    type: "card",
    name: "国家体育总局冬运中心",
    subtitle: "—— 中国首枚冬奥会女子空中技巧金牌获得者徐梦桃",
    desc: "本次备战北京冬奥会的明显变化是，训练中有人工智能小冰的技术分析，可以看技术录像，评测打分，这些都是科技助力。",
    service: "中国国际广播电台",
    url: icon1,
    link: "",
  },
  {
    type: "img",
    url: img12,
  },
  {
    type: "card",
    name: "每日经济新闻",
    subtitle: "—— 每日经济新闻董事长、总编辑",
    desc: "每经AI电视，是改写传播史的革命性产品，它的诞生，宣布进入了视频播放“无人化”时代。",
    service:
      "小冰以AI技术，助力每日经济新闻打造全球首创24小时“AI财经电视”",
    url: icon5,
    link: "https://mp.weixin.qq.com/s/8MF8-9BIhsfBjS-sbmSCRQ",
  },
];
const column2 = [
  {
    type: "card",
    name: "北京人寿",
    subtitle: "",
    desc: "北京人寿与小冰公司联合落地的“数字人+AIGC保险内勤应用”项目被授予“全球保险科技案例”奖。 北京人寿相关工作平均效率提高70%以上，综合成本降低50%，其中，IT项目的实际应用比例提高了70%",
    service: "北京人寿×小冰：数字人项目获“全球保险科技案例” 奖",
    url: icon2,
    link: "https://mp.weixin.qq.com/s/wXUM_OZv4RE-IeedTo7VhA",
  },
  {
    type: "img",
    url: img21,
  },
  {
    type: "card",
    name: "中信出版集团",
    subtitle: "—— 中信出版集团党委书记、董事长",
    desc: "利用人工智能技术为出版知识库构建赋能将成为数字化的底层基础。未来，大模型与出版知识库的结合，将为人类知识生产提供新的可能。AI和出版知识库的双向赋能，将催生新型的出版模式，出版行业也将开启一个内容生产的全新时代。",
    service:
      "中信出版集团与小冰公司联合打造“AI作者数字人”项目，交互数字人已上线",
    url: icon6,
    link: "https://mp.weixin.qq.com/s/5mntKtIMJi8LaQcF5DPukw",
  },
  {
    type: "img",
    url: img22,
  },
];
const column3 = [
  {
    type: "img",
    url: img31,
  },
  {
    type: "card",
    name: "招商局集团",
    subtitle: "",
    desc: "招商局集团正式宣布首位数字员工“招小影”入职，她身怀绝技，正式加入百年招商局与大家共成长。在数字时空中不断蜕变新生的她，将与全体招商人共同奋斗，奋楫驭舟，扬帆远航下个百年征程。",
    service:
      "招商局集团首位数字员工“招小影”背后的黑科技",
    url: icon3,
    link: "https://mp.weixin.qq.com/s/h0AMYSiZzdpUOWu1WGf2eA",
  },
  {
    type: "img",
    url: img32,
  },
  {
    type: "card",
    name: "万科集团",
    subtitle: "—— 万科集团董事会主席",
    desc: "祝贺“崔筱盼”获得 2021年万科总部最佳新人奖！作为万科首位数字员工，“崔筱盼”今年2月1日正式“入职”。在系统算法的加持下，她很快学会了在流程和数据中发现问题的方法，经她催办的预付应收逾期单据核销率达到91.44%。感谢沈向洋博士和小冰团队对“崔筱盼”的支持。",
    service: "惊呆打工人！万科年度优秀新员工，竟然不是人类？",
    url: icon7,
    link: "https://mp.weixin.qq.com/s/Hws3FsmSRW1es6HPu3C9Bg",
  },
];
const column4 = [
  {
    type: "card",
    name: "宝洁",
    subtitle: "—— 宝洁大中华区高级副总裁兼CIO",
    desc: "小冰的数字人直播是一种全新的面向未来的直播形式，展示了数字人技术如何提高直播效率，未来，宝洁将与小冰携手，将数字化能力运用到生意实践，助力品类增长。",
    service:
      "小冰数字人：宝洁2023 Digital Innovation Roadshow唯一数字人解决方案",
    url: icon4,
    link: "https://mp.weixin.qq.com/s/LAn-Z2BPM-2cF2f2d7RpzA",
  },
  {
    type: "img",
    url: img41,
  },
  {
    type: "card",
    name: "屈臣氏",
    subtitle: "",
    desc: "在小冰人工智能技术的赋能下，屈臣氏AI品牌代言人屈晨曦，通过与消费者一对一互动建立情感连接，他温暖、年轻、时尚、活力，是24小时健康美丽顾问，根据消费者需求提供贴心的服务体验，为品牌收获了大量年轻消费者的认可和喜爱。",
    service: "屈臣氏利用AI、私域逆袭增长，实现用户和品牌双轮驱动",
    url: icon8,
    link: "http://retail-it.cn/lins/243.html",
  },
  {
    type: "img",
    url: img42,
  },
];
const HumanCard = ({
  name,
  subtitle,
  desc,
  link,
  url,
  service,
}: {
  name?: string;
  subtitle?: string;
  desc?: string;
  link?: string;
  url?: string;
  service?: string;
}) => {
  return (
    <div className={styles.humanCard}>
      <div className={styles.cardContent}>
        <Flex align="center" gap={12}>
          <div className={styles.humanAvatar}>
          <img src={url} alt={name} /></div>
          <div>
            <div>{name}</div>
          </div>
        </Flex>
        <Flex vertical gap={'.12rem'} className={styles.cardDescription}>
          {desc}
          <div
            style={{
              fontSize: ".12rem",
              color: "#666A80",
              textAlign: 'right'
            }}
          >
           {subtitle}
          </div>
        </Flex>
        <div
          className={styles.cardFooter}
          onClick={() => {
            window.open(link, "_blank");
          }}
        >
          {service}
        </div>
      </div>
    </div>
  );
};
const demo1 = [...column1, ...column1, ...column1, ...column1, ...column1];
const demo2 = [...column2, ...column2, ...column2, ...column2, ...column2];
const demo3 = [...column3, ...column3, ...column3, ...column3, ...column3];
const demo4 = [...column4, ...column4, ...column4, ...column4, ...column4];
const HumanColumnList = ({
  column,
  direct,
}: {
  column: {
    type: string;
    url?: string;
    name?: string;
    desc?: string;
    service?: string;
  }[];
  direct: "up" | "down";
}) => {
  const divRef = useRef<HTMLDivElement>(null);
  const directRef = useRef(direct);
  directRef.current = direct; // Update the direction reference
  const percentRef = useRef(directRef.current === "up" ? 9.9 : 50); // Calculate the percentage based on the number of items
  const stop = useRef(false); // Flag to stop the animation
  const speedRef = useRef(0.01); // Default animation speed

  useEffect(() => {
    const updateStyle = () => {
      if (stop.current) return; // Stop the animation if stop is true
      if (!divRef.current) return;
      if (directRef.current === "up") {
        if (percentRef.current >= 50) {
          percentRef.current = 9.9; // Reset to 0 when reaching 100%
        } else {
          percentRef.current += speedRef.current; // Use the speed reference for animation
        }
      } else {
        if (percentRef.current <= 9.9) {
          percentRef.current = 50; // Reset to 100% when reaching 0%
        } else {
          percentRef.current -= speedRef.current; // Use the speed reference for animation
        }
      }
      divRef.current.style.transform = `translateY(-${percentRef.current}%)`;
      requestAnimationFrame(updateStyle);
    };

    // Start the animation
    requestAnimationFrame(updateStyle);

    // Add event listeners
    const currentDiv = divRef.current;
    if (currentDiv) {
      currentDiv.addEventListener("mouseenter", () => {
        stop.current = true; // Stop the animation on mouse enter
      });

      currentDiv.addEventListener("mouseleave", () => {
        stop.current = false; // Resume the animation on mouse leave
        requestAnimationFrame(updateStyle);
      });
    }
  }, []);

  return (
    <div className={styles.column} ref={divRef}>
      {column.map((item, index) => {
        if (item.type === "img") {
          return (
            <img
              key={index}
              src={item.url}
              alt="Human"
              className={styles.imgCard}
            />
          );
        } else {
          return <HumanCard key={index} {...item} />;
        }
      })}
    </div>
  );
};
const HumanList = () => {
  const [columns, setColumns] = useState([demo1, demo2, demo3, demo4]); // Example with two columns, you can adjust as needed
  const [dir, setDir] = useState<"up" | "down">("up"); // Initial direction
  const [dir2, setDir2] = useState<"up" | "down">("down"); // Initial direction for second column
  // Handle mouse wheel scroll event
  const handleWheel = (e: WheelEvent) => {
    if (e.deltaY > 0) {
      // Scrolling up, move in the opposite direction (down)
      setDir("down");
      setDir2("up");
    } else {
      // Scrolling down, move in the opposite direction (up)
      setDir("up");
      setDir2("down");
    }
  };
  useEffect(() => {
    // Add wheel event listener
    window.addEventListener("wheel", handleWheel);
    // Cleanup event listeners
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <div className={styles.humanList}>
      {columns.map((column, index) => (
        <HumanColumnList
          key={index}
          column={column}
          direct={index % 2 === 0 ? dir : dir2} // Alternate direction for each column
        />
      ))}

      {/* Add your human list components here */}
    </div>
  );
};
export default HumanList;
